
class CapSubmitNewVehicle {
  constructor(config) {
    this.config = config
  }

  checkPermission(options = {}) {
    if (options === undefined) {
      return Boolean(this.config)
    }

    if (options.vendor) {
      return this._checkConfigField('vendor', options)
    }
    else {
      // options is empty
      return Boolean(this.config)
    }
  }

  getVendorOptions() {
    if (this.config?.vendor?.options) {
      return this.config.vendor.options
    }
    return []
  }

  checkFieldRequirement(key) {
    if (key === 'vendor_id' || key === 'vendor') {
      return this.config.vendor.required
    }
  }

  checkFieldProvided(key) {
    if (key === 'vendor_id') {
      return this._checkProvidedMap(this.config.vendor.provided, 'vendor_id')
    }
  }

  _checkProvidedMap(map, key) {
    if (map) {
      return map[key]
    }
    else {
      return undefined
    }
  }

  _checkConfigField(fieldKey, options) {
    if (this.config[fieldKey]) {
      return this.config[fieldKey].includes(options[fieldKey])
    }
    else {
      return false
    }
  }
}

function key() {
  return 'submit_new_vehicle'
}

function create(config) {
  return new CapSubmitNewVehicle(config)
}

export default {
  key,
  create,
}
